export const MESSAGES = {
  ACCOUNT: {
    CREATED: 'Account created',
    DEACTIVATED: 'Account deactivated',
    REACTIVATED: 'Account reactivated',
    UPDATED: 'Account updated',
  },
  ALLOCATIONS: {
    TEMPLATE: {
      CREATED: 'Allocation template created',
      DELETED: 'Allocation template deleted',
      UPDATED: 'Allocation template updated',
    },
    GENERATED: 'Allocations generated',
    UPDATED: 'Allocations updated',
  },
  BILL: {
    CREATED: 'Bill created',
    DELETED: 'Bill deleted',
    UPDATED: 'Bill updated',
  },
  BUDGET: {
    CREATED: 'Budget created',
    DELETED: 'Budget deleted',
    ONE_SERVICE_TYPE_REQUIRED: 'At least one service type is required',
    UPDATED: 'Budget updated',
  },
  CREDENTIAL: {
    CREATED: 'Credential created',
    DELETED: 'Credential deleted',
    UPDATED: 'Credential updated',
  },
  DASHBOARD: {
    DELETION_ERROR: 'Unable to delete dashboard, please try again later',
  },
  ENERGY_ASSET: {
    CREATED: 'Energy asset created',
    DELETED: 'Energy asset deleted',
    UPDATED: 'Energy asset updated',
  },
  FACILITY: {
    ADD_TO_ES: 'Facility added to ENERGY STAR',
    UPDATE_ES: 'ES score and metrics updated successfully',
    CREATED: 'Facility created',
    DEACTIVATED: 'Facility deactivated',
    ONE_REQUIRED: 'At least one facility is required',
    REACTIVATED: 'Facility reactivated',
    UPDATED: 'Facility updated',
  },
  FACILITY_GROUP: {
    CREATED: 'Facility group created',
    DELETED: 'Facility group deleted',
    UPDATED: 'Facility group updated',
  },
  GENERIC: {
    CONTACT_REQUEST_SENT: 'A contact request was sent',
    ERROR: 'Something went wrong, please try again later',
    FORM_FIELDS_ERROR: 'Some form fields need your attention',
    MESSAGE_COPIED: 'Message copied to clipboard',
    SIGNUP_SUCCESS: 'Welcome to Nimble Energy!',
  },
  LINE_ITEM: {
    CREATED: 'Line item created',
    DELETED: 'Line item deleted',
    ONE_REQUIRED: 'At least one bill line item is required',
    SUBTYPE: {
      CREATED: 'Line item subtype created',
      DELETED: 'Line item subtype deleted',
      UPDATED: 'Line item subtype updated',
    },
    TOTAL_ERROR: 'Line item total must equal bill amount',
    UPDATED: 'Line item updated',
  },
  METER: {
    CREATED: 'Meter created',
    DEACTIVATED: 'Meter deactivated',
    MARKED_REVIEWED: 'Meter marked as reviewed',
    REACTIVATED: 'Meter reactivated',
    UPDATED: 'Meter updated',
  },
  PASSWORD: {
    CHANGED: 'Password changed successfully',
    CHANGE_ERROR:
      'Password change failed, please verify information and try again',
    FORGOT_ERROR:
      'Unable to send password reset email, please verify your information and try again.',
    RESET_EMAIL_SENT: 'A password reset email was sent',
  },
  ORGANIZATION: {
    CREATED: 'Organization created',
    DEACTIVATED: 'Organization deactivated',
    REACTIVATED: 'Organization reactivated',
    SWITCH_ERROR: 'An error occurred while switching organization',
    UPDATED: 'Organization updated',
  },
  ORGANIZATION_GROUP: {
    CREATED: 'Organization group created',
    DELETED: 'Organization group deleted',
    UPDATED: 'Organization group updated',
  },
  PROJECT: {
    CREATED: 'Project created',
    DELETED: 'Project deleted',
    UPDATED: 'Project updated',
  },
  USER: {
    CREATED: 'User created',
    DEACTIVATED: 'User deactivated',
    REACTIVATED: 'User reactivated',
    UPDATED: 'User updated',
  },
  UTILITY: {
    CREATED: 'Utility created',
    DEACTIVATED: 'Utility deactivated',
    REACTIVATED: 'Utility reactivated',
    UPDATED: 'Utility updated',
  },
  UPLOAD_FILES: {
    ERROR: 'Something went wrong while uploading files',
    SUCCESS: 'Files uploaded successfully',
  },
  WORK_ORDER: {
    CREATED: 'Work order created',
    DELETED: 'Work order deleted',
    UPDATED: 'Work order updated',
  },
};
